import { SUM_FUNCTION_NAME } from 'pages/Waterfall/SpreadsheetConfig/FundSummarySheetConfig/WaterfallFundSummaryParser/WaterfallFundSummaryParser.constants';

export const buildExitProceedsExpr = (
  entityId: number | string,
  additionalEntityIds?: (number | string)[],
  availableSheetNames: ReadonlySet<string> | readonly string[] = []
) => {
  const available = availableSheetNames instanceof Set ? availableSheetNames : new Set(availableSheetNames);
  const baseSheetName = `FundInvestment_${entityId}__f`;

  // Summary must not reference FundInvestment sheets that are not in the workbook yet
  // (e.g. primary FO loaded before weighted-share sheets, or CFL-only funds with no sheet).
  if (!available.has(baseSheetName)) {
    return null;
  }

  const baseExpr = `${baseSheetName}.totalValue`;

  if (!additionalEntityIds || additionalEntityIds.length === 0) {
    return `=${baseExpr}`;
  }

  const additionalExprs = additionalEntityIds
    .map(id => `FundInvestment_${entityId}_${id}__f`)
    .filter(sheetName => available.has(sheetName))
    .map(sheetName => `${sheetName}.totalValue`);

  if (additionalExprs.length === 0) {
    return `=${baseExpr}`;
  }

  return `=${SUM_FUNCTION_NAME}(${[baseExpr, ...additionalExprs].join(', ')})`;
};

// MOIC expression builder; expects fully-qualified cell refs for exit, previous, and invested
export const buildMoicExpr = (exitRef: string, prevRef: string, investedRef: string) =>
  `=(${exitRef}+${prevRef})/${investedRef}`;
